function trimTrailingSlash(s: string): string {
  return s.replace(/\/$/, '');
}

const viteApiUrl = trimTrailingSlash(
  ((import.meta.env.VITE_API_URL as string | undefined) ?? '').trim()
);

/**
 * Base URL for survey API calls. Empty string = same-origin (Nginx proxies /api).
 * In dev, Vite proxies /api → localhost:4001.
 * Set VITE_API_URL only if the API is on a different domain from the frontend.
 */
export const API_BASE_URL =
  import.meta.env.DEV &&
  (viteApiUrl === '' || viteApiUrl === 'http://localhost:4001')
    ? ''
    : viteApiUrl;
